// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/DeliveryTerms.yaml
// Generated: 2026-03-26T19:53:51.554Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateDeliveryTerms, UpdateDeliveryTerms, DeliveryTerms } from '@/types/core/DeliveryTerms';

/**
 * DeliveryTerms Service
 * CRUD operations for DeliveryTerms via the ABP API.
 */
export const deliveryTermsService = new EntityService<DeliveryTerms, CreateDeliveryTerms, UpdateDeliveryTerms>(
  '/api/core/deliveryterms',
  'DeliveryTerms',
);
